export default __webpack_public_path__ + "static/kpoint_dark_logo-2bbfae375ac8c7157207591a1558cc2e.png";